import {create} from 'zustand';

interface PhotoBoxState {
  uploadedImage: string;
}

interface PhotoBoxActions {
  setUploadedImage: (image: string) => void;
  resetUploadedImage: () => void;
}

interface PhotoBoxStore extends PhotoBoxState, PhotoBoxActions {}

const INITIAL_STATE: PhotoBoxState = {
  uploadedImage: '',
};

export const usePhotoBoxStore = create<PhotoBoxStore>()(set => ({
  ...INITIAL_STATE,

  setUploadedImage: image => set({uploadedImage: image}),

  resetUploadedImage: () => set({uploadedImage: ''}),
}));
